import React from "react";
import missing_image from "./../../../i/missing_image.svg";
import { MetricTable, truncate } from "./../Utils.js";

const metricBar = (cell) => (
  <MetricTable {...cell} graph={cell.trends} graphType="bar" />
);

export const XrayTooltipContent = (props) => {
  const { data } = props;

  const topContent = data.activePayload[0].payload.topContent;
  let IMAGE = { backgroundImage: `url(${missing_image})` };

  if (topContent) {
    if (topContent.thumbnail)
      IMAGE = {
        backgroundImage: `url(${topContent.thumbnail})`,
      };

    topContent.value = topContent.views;
    topContent.trends.forEach((chartData) => {
      chartData.value = chartData.views;
      chartData.label = chartData.date;
      // eslint-disable-next-line no-self-assign
      chartData.selected = chartData.selected;
    });
  }

  return (
    <main className="standard-tooltip__main">
      <div className="standard-tooltip__dilimiter2 mt-3" />
      <div className="standard-tooltip__section-header my-2">
        Top content on this day.
      </div>
      <div className="standard-tooltip__details--posts">
        <article className="content-table">
          <figure className="content-table__figure">
            <div className="content-table__img" style={IMAGE} />
          </figure>

          <section className="content-table__detail">
            <span className="standard-tooltip__value">
              {metricBar(topContent)}
            </span>
          </section>
        </article>

        <div className="standard-tooltip__text">
          {truncate(topContent.title, 200)}
        </div>
      </div>
    </main>
  );
};
